import { RichTextEditor } from "@/components/RichTextEditor/RichTextEditor";
import {
  ControlProps,
  optionIs,
  RankedTester,
  rankWith,
} from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import React, { useCallback } from "react";

const MarkdownEditorControlComponent: React.FC<ControlProps> = ({
  data,
  enabled,
  handleChange,
  path,
  visible,
}) => {
  const readonly = !enabled;
  const content = typeof data === "string" ? data : "";

  const handleEditorChange = useCallback(
    (markdown: string) => {
      handleChange(path, markdown);
    },
    [handleChange, path],
  );

  if (!visible) return null;

  return (
    <RichTextEditor
      value={content}
      onChange={readonly ? undefined : handleEditorChange}
      readOnly={readonly}
      showToolbar={true}
      enableSkills={false}
      enableEntities={false}
      enablePlaceholders={false}
      placeholder="Skill instructions..."
      // Remove the editor's own border/rounding so it merges flush with the
      // tool confirmation container — no nested boxes.
      className="border-0 rounded-none shadow-none -mx-4 -mt-8 -mb-4"
      editorClassName="min-h-[16rem] overflow-y-auto"
    />
  );
};

/**
 * Tester — matches when ui_schema has: options: { control: "markdown_editor" }
 */
export const markdownEditorTester: RankedTester = rankWith(
  5,
  optionIs("control", "markdown_editor"),
);

export const MarkdownEditorControl = withJsonFormsControlProps(
  MarkdownEditorControlComponent,
);
